export default function(user) {
  var show_survey_callback = function() {
    var date = new Date();
    window.Intercom('update', { last_wootric_surveyed_at: Math.round(date.getTime() / 1000) });
  };

  var decline_submitted_callback = function() {
    var date = new Date();
    window.Intercom('update', { last_wootric_declined__at: Math.round(date.getTime() / 1000) });
  };

  var response_submitted_callback = function(score, comment) {
    window.Intercom('update', { last_wootric_score: score });
    window.Intercom('update', { last_wootric_comment: comment });
  };

  // window.wootric_survey_immediately = true; // Shows survey immediately for testing purposes.  TODO: Comment out for production.
  window.wootricSettings = {
    email: user.email,
    external_id: user.id,
    account_token: 'NPS-5ca1f1da', // This is your unique account token.
    survey_callback: show_survey_callback,
    decline_callback: decline_submitted_callback,
    response_callback: response_submitted_callback,
  };

  setTimeout(() => {
    if (window.wootric) {
      // need this in case UBlock blocks wootric?
      window.wootric('run');
    }
  });
}
